/**
 * E2E Test Data Enums
 *
 * These enums define the test data used in E2E tests and seed scripts.
 * They ensure consistency between backend seed data and frontend E2E tests.
 */
/**
 * E2E Test User Email Addresses
 * Used to identify specific test users in E2E tests
 */
export var E2E_TEST_USER_EMAILS;
(function (E2E_TEST_USER_EMAILS) {
    E2E_TEST_USER_EMAILS["OWNER"] = "e2e-test@pilatestime.com.br";
    E2E_TEST_USER_EMAILS["ADMIN"] = "e2e-test-admin@pilatestime.com.br";
    E2E_TEST_USER_EMAILS["MANAGER"] = "e2e-test-manager@pilatestime.com.br";
    E2E_TEST_USER_EMAILS["MEDICAL_PROFESSIONAL"] = "e2e-test-medical-professional@pilatestime.com.br";
    E2E_TEST_USER_EMAILS["ACCOUNTANT"] = "e2e-test-accountant@pilatestime.com.br";
    E2E_TEST_USER_EMAILS["VIEWER"] = "e2e-test-viewer@pilatestime.com.br";
    E2E_TEST_USER_EMAILS["MULTI_ORG_USER"] = "e2e-test-multi-org-user@pilatestime.com.br";
})(E2E_TEST_USER_EMAILS || (E2E_TEST_USER_EMAILS = {}));
/**
 * E2E Test Customer Email Addresses
 * Used to identify specific test customers in E2E tests
 */
export var E2E_CUSTOMER_EMAILS;
(function (E2E_CUSTOMER_EMAILS) {
    E2E_CUSTOMER_EMAILS["CARLOS_SANTOS"] = "carlos.santos@example.com";
    E2E_CUSTOMER_EMAILS["ENROLLED_USER"] = "enrolled.user@example.com";
    E2E_CUSTOMER_EMAILS["UNENROLLED_USER"] = "unenrolled.user@example.com";
    E2E_CUSTOMER_EMAILS["MARIA_SILVA"] = "maria.silva@wellness.com";
    E2E_CUSTOMER_EMAILS["JOAO_OLIVEIRA"] = "joao.oliveira@wellness.com";
    E2E_CUSTOMER_EMAILS["ANA_COSTA"] = "ana.costa@wellness.com";
    E2E_CUSTOMER_EMAILS["ENROLLMENT_NEW_INLINE_TEST"] = "enrollment_new_inline_test@example.com";
    E2E_CUSTOMER_EMAILS["ENROLLMENT_NEW_EXISTING_TEST"] = "enrollment_new_existing_test@example.com";
    E2E_CUSTOMER_EMAILS["PLACEHOLDER_003"] = "NeededForPagination003@example.com";
    E2E_CUSTOMER_EMAILS["PLACEHOLDER_004"] = "NeededForPagination004@example.com";
    E2E_CUSTOMER_EMAILS["PLACEHOLDER_005"] = "NeededForPagination005@example.com";
    E2E_CUSTOMER_EMAILS["PLACEHOLDER_006"] = "NeededForPagination006@example.com";
    E2E_CUSTOMER_EMAILS["PLACEHOLDER_007"] = "NeededForPagination007@example.com";
    E2E_CUSTOMER_EMAILS["PLACEHOLDER_008"] = "NeededForPagination008@example.com";
    E2E_CUSTOMER_EMAILS["PLACEHOLDER_009"] = "NeededForPagination009@example.com";
    E2E_CUSTOMER_EMAILS["PLACEHOLDER_010"] = "NeededForPagination010@example.com";
    E2E_CUSTOMER_EMAILS["PLACEHOLDER_011"] = "NeededForPagination011@example.com";
    E2E_CUSTOMER_EMAILS["PLACEHOLDER_012"] = "NeededForPagination012@example.com";
})(E2E_CUSTOMER_EMAILS || (E2E_CUSTOMER_EMAILS = {}));
/**
 * E2E Test Customer Plan Names
 * Used to identify specific test customer plans in E2E tests
 */
export var E2E_CUSTOMER_PLAN_NAMES;
(function (E2E_CUSTOMER_PLAN_NAMES) {
    E2E_CUSTOMER_PLAN_NAMES["BASIC_MAX_2_SESSIONS"] = "Basic-max-2-sessions";
    E2E_CUSTOMER_PLAN_NAMES["PREMIUM_MAX_5_SESSIONS"] = "Premium-max-5-sessions";
    E2E_CUSTOMER_PLAN_NAMES["ELITE_MAX_20_SESSIONS"] = "Elite-max-20-sessions";
    E2E_CUSTOMER_PLAN_NAMES["ELITE_UNLIMITED"] = "StillNotUsedInSpecificTests001";
    E2E_CUSTOMER_PLAN_NAMES["STUDENT_PLAN"] = "StillNotUsedInSpecificTests002";
    E2E_CUSTOMER_PLAN_NAMES["SENIOR_PLAN"] = "StillNotUsedInSpecificTests003";
    E2E_CUSTOMER_PLAN_NAMES["MONTHLY_UNLIMITED"] = "StillNotUsedInSpecificTests004";
    E2E_CUSTOMER_PLAN_NAMES["QUARTERLY_PREMIUM"] = "StillNotUsedInSpecificTests005";
    E2E_CUSTOMER_PLAN_NAMES["SEMI_ANNUAL_ELITE"] = "StillNotUsedInSpecificTests006";
    E2E_CUSTOMER_PLAN_NAMES["SEMI_ANNUAL_ELITE_UNLIMITED"] = "StillNotUsedInSpecificTests007";
    E2E_CUSTOMER_PLAN_NAMES["ANNUAL_PREMIUM"] = "StillNotUsedInSpecificTests008";
    E2E_CUSTOMER_PLAN_NAMES["ANNUAL_ELITE"] = "StillNotUsedInSpecificTests009";
    E2E_CUSTOMER_PLAN_NAMES["ANNUAL_ELITE_UNLIMITED"] = "StillNotUsedInSpecificTests010";
})(E2E_CUSTOMER_PLAN_NAMES || (E2E_CUSTOMER_PLAN_NAMES = {}));
/**
 * E2E Test Schedule Names
 * Used to identify specific test schedules in E2E tests
 */
export var E2E_TEST_SCHEDULES;
(function (E2E_TEST_SCHEDULES) {
    E2E_TEST_SCHEDULES["GROUP_MORNING_PILATES"] = "Weekly Group - Morning Pilates";
    E2E_TEST_SCHEDULES["INDIVIDUAL_PRIVATE_SESSION"] = "Individual - Private Session";
    E2E_TEST_SCHEDULES["GROUP_EVENING_CLASS"] = "Weekly Group - Evening Class";
    E2E_TEST_SCHEDULES["GROUP_AFTERNOON_REFORMER"] = "Weekly Group - Afternoon Reformer";
    E2E_TEST_SCHEDULES["INDIVIDUAL_MORNING_SESSION"] = "Individual - Morning Session";
    E2E_TEST_SCHEDULES["GROUP_WEEKEND_PILATES"] = "Weekly Group - Weekend Pilates";
    E2E_TEST_SCHEDULES["GROUP_LUNCHTIME_EXPRESS"] = "Weekly Group - Lunchtime Express";
    E2E_TEST_SCHEDULES["INDIVIDUAL_EVENING_SESSION"] = "Individual - Evening Session";
    E2E_TEST_SCHEDULES["GROUP_EARLY_BIRD"] = "Weekly Group - Early Bird";
    E2E_TEST_SCHEDULES["GROUP_MAT_PILATES"] = "Weekly Group - Mat Pilates";
    E2E_TEST_SCHEDULES["INDIVIDUAL_AFTERNOON_SESSION"] = "Individual - Afternoon Session";
    E2E_TEST_SCHEDULES["GROUP_ADVANCED_CLASS"] = "Weekly Group - Advanced Class";
    E2E_TEST_SCHEDULES["GROUP_BEGINNER_FRIENDLY"] = "Weekly Group - Beginner Friendly";
    E2E_TEST_SCHEDULES["INDIVIDUAL_WEEKEND_SESSION"] = "Individual - Weekend Session";
    E2E_TEST_SCHEDULES["GROUP_CORE_STRENGTH"] = "Weekly Group - Core Strength";
    // Dedicated schedules for edit tests (to prevent test interference)
    E2E_TEST_SCHEDULES["EDIT_TEST_BASIC_UPDATES"] = "Edit Test - Basic Updates";
    E2E_TEST_SCHEDULES["EDIT_TEST_EXTEND_END_DATE"] = "Edit Test - Extend End Date";
    E2E_TEST_SCHEDULES["EDIT_TEST_REDUCE_END_DATE"] = "Edit Test - Reduce End Date";
    E2E_TEST_SCHEDULES["EDIT_TEST_REDUCE_END_DATE_CANCEL"] = "Edit Test - Reduce End Date Cancel";
    E2E_TEST_SCHEDULES["EDIT_TEST_TIME_CHANGES"] = "Edit Test - Time Changes";
    E2E_TEST_SCHEDULES["EDIT_TEST_MULTI_UPDATE"] = "Edit Test - Multi Update";
})(E2E_TEST_SCHEDULES || (E2E_TEST_SCHEDULES = {}));
/**
 * E2E Test Establishment Names
 * Used to identify specific test establishments in E2E tests
 */
export var E2E_ESTABLISHMENT_NAMES;
(function (E2E_ESTABLISHMENT_NAMES) {
    E2E_ESTABLISHMENT_NAMES["MAIN_STUDIO"] = "Main Studio";
    E2E_ESTABLISHMENT_NAMES["DOWNTOWN_BRANCH"] = "Downtown Branch";
    E2E_ESTABLISHMENT_NAMES["NORTH_LOCATION"] = "North Location";
})(E2E_ESTABLISHMENT_NAMES || (E2E_ESTABLISHMENT_NAMES = {}));
/**
 * E2E Test Organization Names
 * Used to identify specific test organizations in E2E tests
 */
export var E2E_ORGANIZATION_NAMES;
(function (E2E_ORGANIZATION_NAMES) {
    E2E_ORGANIZATION_NAMES["BLANK"] = "E2E Test Blank Organization";
    E2E_ORGANIZATION_NAMES["PRIMARY_PILATES_STUDIO"] = "E2E Test Primary Pilates Studio";
    E2E_ORGANIZATION_NAMES["SECONDARY_WELLNESS_CENTER"] = "E2E Test Secondary Wellness Center";
    E2E_ORGANIZATION_NAMES["MULTI_ORG_USER_CROSS_ACCESS_TEST"] = "E2E-MultiOrganizationUserCrossAccessTest";
    E2E_ORGANIZATION_NAMES["FEAT_FLAG_ENROLLMENT_WORKFLOW_INLINE_AND_EXISTING"] = "E2E-FeatFlagEnrollmentScheduleWorkflow-InlineAndExisting";
    E2E_ORGANIZATION_NAMES["FEAT_FLAG_ENROLLMENT_WORKFLOW_EXISTING_ONLY"] = "E2E-FeatFlagEnrollmentScheduleWorkflow-ExistingOnly";
    E2E_ORGANIZATION_NAMES["FEAT_FLAG_ENROLLMENT_WORKFLOW_INLINE_ONLY"] = "E2E-FeatFlagEnrollmentScheduleWorkflow-InlineOnly";
    // Organizations with different platform plans for testing billing features
    E2E_ORGANIZATION_NAMES["STARTER_PLAN_STUDIO"] = "E2E-StarterPlanStudio";
    E2E_ORGANIZATION_NAMES["PROFESSIONAL_PLAN_STUDIO"] = "E2E-ProfessionalPlanStudio";
    E2E_ORGANIZATION_NAMES["ENTERPRISE_PLAN_STUDIO"] = "E2E-EnterprisePlanStudio";
})(E2E_ORGANIZATION_NAMES || (E2E_ORGANIZATION_NAMES = {}));
//# sourceMappingURL=E2ETestData.js.map